import { CardMedia, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

const NotFound = () => {
    return (
        <Box>
            {/* not found page  */}
            <Box sx={{ mx: { xs: 1.2, sm: 3.5, md: 6, lg: 9, xl: 28 }, display: 'flex', alignItems: 'center' }}>
                <CardMedia
                    component="img"
                    sx={{ width: { xs: '100%' }, mx: 'auto' }}
                    image="https://i.ibb.co/k9NNpRV/404-error-page.jpg"
                    alt="logo"
                />
            </Box>
            <Typography sx={{ pt: 2, pb: 5 }} style={{ letterSpacing: '2px', color: '#ff0800', fontWeight: 500, fontFamily: 'poppins' }} variant="h5" component="div">
                Page Not Found
            </Typography>
        </Box>
    );
};

export default NotFound;